import PaymentMode from '@/assets/enums/invoicing/PaymentMode.js'

export interface StatusPayment {
  payment_status?: string | null
  payment_mode?: string | null
  amount?: number | string | null
}

/**
 * A caution cheque is a guarantee that is not cashed: it never settles the
 * document, so it must neither change the status of the invoice nor of the
 * dossier.
 */
export function isCautionPayment(
  paymentMode: string | null | undefined
): boolean {
  return paymentMode === PaymentMode.CAUTION_CHECK
}

/**
 * The amount really received on a document: received payments, caution
 * cheques excluded (the API leaves them out of `total_paid` as well).
 */
export function receivedAmount(
  payments: StatusPayment[] | null | undefined
): number {
  return (payments ?? [])
    .filter(
      (payment) =>
        payment.payment_status === 'REC' &&
        !isCautionPayment(payment.payment_mode)
    )
    .reduce((sum, payment) => sum + Number(payment.amount ?? 0), 0)
}

/**
 * The status to propose once `payment` is recorded: paid when what is received
 * covers the total, partially paid otherwise. Null for a caution cheque, which
 * proposes nothing.
 */
export function proposedInvoiceStatus(
  payments: StatusPayment[] | null | undefined,
  payment: StatusPayment,
  totalTvac: number | string
): 'PAI' | 'PP' | null {
  if (isCautionPayment(payment.payment_mode)) {
    return null
  }

  const received =
    receivedAmount(payments) +
    (payment.payment_status === 'REC' ? Number(payment.amount ?? 0) : 0)

  return received >= Number(totalTvac) ? 'PAI' : 'PP'
}
